import get from 'lodash/get';
import includes from 'lodash/includes';

import { graphQLClient } from '../../graphQLClients';

import { DeleteItemGqlQuery } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';
import { errorMessageStatusOrErrorsIsIncorrect } from '../../reactQueryConstants';

interface DeleteItemProps<DeleteItemInput> {
  action: string;
  query: DeleteItemGqlQuery;
  queryInput: DeleteItemInput;
}

const successQueryStatuses = ['deleted', 'success'];

export function deleteItem<DeleteItemInput, DeleteItemResponse>({
  action,
  query,
  queryInput
}: DeleteItemProps<DeleteItemInput>) {
  const { rawName, name } = getQueryName(query, 'mutation');

  productionConsole(
    'log',
    'deleteItem',
    { action, queryInput },
    rawName,
    JSON.stringify(queryInput)
  );

  const requestId = generateUuid();

  graphQLClient.addQueryParams(name, requestId);

  return new Promise<DeleteItemResponse>((resolve, reject) => {
    return graphQLClient
      .request<DeleteItemResponse, DeleteItemInput>(query, queryInput, {
        requestId
      })
      .then((response) => {
        if (includes(successQueryStatuses, get(response, `${action}.status`))) {
          return resolve(response);
        }

        const errors = get(response, `${action}.errors`);

        reject(errors ? errors : errorMessageStatusOrErrorsIsIncorrect);
      })
      .catch((reason) => reject(reason));
  });
}
